import { useEffect, useState } from 'react';
import { formatearCOP, vueltoDe } from '@tanteo/compartido';
import { Boton, CampoNumero, FilaAcciones } from '../../ui/base';
import { Modal } from '../../ui/Modal';
import { DIGITOS_DE_PLATA } from '../../lib/lector';

/**
 * La calculadora del cambio: se escribe con cuánto pagaron y dice cuánto devolver. No toca la venta
 * ni guarda nada. `aPagar` es solo lo que se paga en efectivo, también cuando el pago es mixto.
 */
export function Cambio({
  abierto,
  aPagar,
  onCerrar,
}: {
  abierto: boolean;
  aPagar: number;
  onCerrar: () => void;
}) {
  const [recibido, setRecibido] = useState<number | null>(null);

  // Cada apertura empieza en blanco: el monto del cliente anterior no sirve para esta venta.
  useEffect(() => {
    if (abierto) setRecibido(null);
  }, [abierto]);

  const vuelto = vueltoDe(recibido, aPagar);

  return (
    <Modal abierto={abierto} titulo="Calcular el cambio" onCerrar={onCerrar}>
      <div className="space-y-3">
        <p className="flex items-baseline justify-between">
          <span className="text-muted text-contenido font-bold uppercase">A pagar en efectivo</span>
          <span className="num text-cifra font-extrabold" data-e2e="cambio-a-pagar">
            {formatearCOP(aPagar)}
          </span>
        </p>

        <CampoNumero
          etiqueta="¿Con cuánto pagó?"
          plata
          min={0}
          valor={recibido}
          onValor={setRecibido}
          lector={{ maxDigitos: DIGITOS_DE_PLATA }}
          data-e2e="cambio-recibido"
        />

        {vuelto !== null && (
          <p
            className={`flex items-baseline justify-between text-cifra font-extrabold ${
              vuelto < 0 ? 'text-destructive' : 'text-success'
            }`}
            data-e2e="cambio-vuelto"
          >
            <span>{vuelto === 0 ? 'SIN VUELTO' : vuelto < 0 ? 'FALTAN' : 'DEVOLVER'}</span>
            <span className="num">{vuelto === 0 ? '' : formatearCOP(Math.abs(vuelto))}</span>
          </p>
        )}

        <p className="text-muted text-contenido">Solo para calcular: no cambia la venta ni queda guardado.</p>

        <FilaAcciones>
          <Boton variante="contorno" onClick={onCerrar} data-e2e="cambio-cerrar">
            Cerrar
          </Boton>
        </FilaAcciones>
      </div>
    </Modal>
  );
}
